export const GET_PATIENT_STATS = 'GET_PATIENT_STATS';
export const GET_EMAIL_MILESTONE = 'GET_EMAIL_MILESTONE';
export const GET_LOGIN_MILESTONE = 'GET_LOGIN_MILESTONE';
export const GET_FORM_MILESTONE = 'GET_FORM_MILESTONE';
export const GET_APPOINTMENT_PROCESS_TRACKER = 'GET_APPOINTMENT_PROCESS_TRACKER';

export const LOADER = 'LOADER';




